<template>
    <admin-layout class="element-edit" v-if="form">

        <app-content-pane class="ml-3">

            <template #title>
                <div class="px-4 pt-3">
                    <h1 class="mb-2">
                        {{ form.name }}
                    </h1>
                    <h6 class="text-muted">
                        <strong>{{ type_name }}</strong> /
                        {{ form.name }}
                    </h6>
                </div>
                <hr class="mb-0">
            </template>

            <section class="px-3 py-4 form">
                <form action="" @submit.prevent="save()" autocomplete="off">
                    <div class="row">

                        <div v-if="is_admin" class="col-12 col-lg-6 order-1 order-lg-2">
                            <div class="form-group">
                                <div class="tenants mb-3">
                                    <h5 class="mb-3">Tenants</h5>
                                    <error-line field="tenants"/>
                                    <div v-for="tenant in tenants" :key="tenant.id">
                                        <input type="checkbox" v-model="form.tenants" :id="`tenant-${tenant.id}`" :value="tenant.id">
                                        <label class="ml-2 mb-1" :for="`tenant-${tenant.id}`">
                                            {{ tenant.name }}
                                            <strong>({{ tenant.handle }})</strong>
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <groups-connector v-model="form.groups"/>

                        </div>

                        <div class="col-12 col-lg-6 order-2 order-lg-1">

                            <div class="form-group">
                                <label>Title</label>
                                <input type="text" class="form-control form-control-lg" v-model="form.name">
                                <error-line field="name"/>
                            </div>

                            <div class="checkboxes">
                                <div class="checkbox" v-for="stage in stages" :key="stage.id">
                                    <image-check v-model="form.groups"
                                                 :value="stage.id"
                                                 :image="stage.meta?.icon">
                                        {{ stage.description }}
                                    </image-check>
                                </div>
                            </div>

                            <div class="card mb-3" v-if="type === 'activity'">
                                <div class="card-body">
                                    <div class="categories">
                                        <h5 class="mb-3">Categories</h5>
                                        <div v-for="category in categories" :key="category.id">
                                            <input type="checkbox" v-model="form.groups" :id="`group-${category.id}`" :value="category.id">
                                            <label class="ml-2 mb-1" :for="`group-${category.id}`">{{ category.name }}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <error-line field="data.groups" class="mt-2 mb-3"/>

                            <!-- RESOURCE -->

                            <template v-if="type === 'resource'">
                                <div class="form-group">
                                    <label>Resource Type</label>
                                    <select class="form-control" v-model="d.type">
                                        <option value="link">External URL</option>
                                        <option value="embed">Embed Code</option>
                                        <option value="file">Upload File</option>
                                        <option value="podcast">Podcast</option>
                                    </select>
                                    <error-line field="data.type"/>
                                </div>

                                <div class="form-group" v-if="d.type === 'link'">
                                    <label>External Link</label>
                                    <div class="input-group">
                                        <input type="url" class="form-control" v-model="d.url" placeholder="https://website.com">
                                    </div>
                                    <div v-if="d.url" class="mt-2">
                                        <a target="_blank"
                                           :href="d.type === 'file' ? uploads.url( d.url ) : d.url"
                                           class="btn btn-dark">Download / Preview Resource</a>
                                    </div>
                                    <error-line field="file"/>
                                </div>

                                <div class="form-group" v-if="d.type === 'embed'">
                                    <label>Embed Code</label>
                                    <div class="input-group">
                                        <textarea type="url" class="form-control" v-model="d.url" placeholder="Embed Code"></textarea>
                                    </div>
                                    <error-line field="file"/>
                                </div>

                                <div class="form-group">
                                    <file-uploader v-model="d.file" storage-path="resources" />
                                </div>

                            </template>


                            <!-- ACTIVITY -->

                            <template v-else-if="type === 'activity'">

                                <div class="form-group">
                                    <label>Student Worksheet</label>
                                    <file-uploader v-model="d.file" storage-path="activities"/>
                                </div>

                                <div class="form-group">
                                    <label>Teacher's Instruction Document</label>
                                    <file-uploader v-model="d.teacher_file" storage-path="activities"/>
                                </div>

                                <div class="form-group">
                                    <label>Preview Image</label>
                                    <file-uploader v-model="d.preview_file" storage-path="activities-preview"/>
                                </div>

                                <div class="form-group">
                                    <label>Description</label>
                                    <textarea class="form-control" v-model="d.description"></textarea>
                                    <error-line field="data.description"/>
                                </div>

                                <div class="form-group">
                                    <label>Teacher Instructions</label>
                                    <textarea class="form-control" v-model="d.teacher_instructions"></textarea>
                                    <error-line field="data.description"/>
                                </div>

                                <div class="form-group">
                                    <label>Student Instructions</label>
                                    <textarea class="form-control" v-model="d.student_instructions"></textarea>
                                    <error-line field="data.description"/>
                                </div>
                            </template>

                            <div class="form-group">
                                <label>Width</label>

                                <div class="checkboxes">
                                    <div class="checkbox"><image-check v-model="d.options.width" type="radio" value="1" image="/images/activity-widths/w1.svg"></image-check></div>
                                    <div class="checkbox"><image-check v-model="d.options.width" type="radio" value="2" image="/images/activity-widths/w2.svg"></image-check></div>
                                    <div class="checkbox"><image-check v-model="d.options.width" type="radio" value="3" image="/images/activity-widths/w3.svg"></image-check></div>
                                    <div class="checkbox"><image-check v-model="d.options.width" type="radio" value="4" image="/images/activity-widths/w4.svg"></image-check></div>
                                    <div class="checkbox"><image-check v-model="d.options.width" type="radio" value="5" image="/images/activity-widths/w5.svg"></image-check></div>
                                </div>

                                <error-line field="data.options"/>
                            </div>

                        </div>

                    </div>

                    <div class="form-group">
                        <button type="submit"
                                class="btn btn-primary">Save</button>
                    </div>

                </form>
            </section>


        </app-content-pane>
    </admin-layout>
</template>

<script>
import AdminLayout from "@/Layouts/AdminLayout";
import AppContentPane from "@/Components/AppContentPane";
import ErrorLine from "@/Components/Common/ErrorLine";
import FileUploader from "@/Components/Common/FileUploader";
import uploads from "@/mixins/uploads";
import IconCheck from "@/Icons/IconCheck";
import ImageCheck from "@/Components/Common/ImageCheck";
import GroupsConnector from "@/Components/Common/GroupsConnector";

export default {
    name: "Edit",
    components: {GroupsConnector, ImageCheck, IconCheck, AdminLayout, AppContentPane, ErrorLine, FileUploader},
    props: ['element', 'type', 'groups', 'tenants'],
    mixins: [uploads],

    data(){
        return {
            is_busy: false,
            form: null,
            test: {
                check: [],
            }
        }
    },

    computed: {
        type_name(){
            switch (this.type) {
                case 'resource': return 'Resources';
                case 'activity': return 'Activities';
            }
            return 'Unknown';
        },

        d(){
            return this.form?.d;
        },

        stages(){
            return this.groups?.filter(g => g.type === 'stage');
        },

        categories(){
            return this.groups?.filter(g => g.type === 'activity-group');
        },

        connected_group_ids(){
            return this.element.groups.map(g => g.id);
        },
    },

    methods:{

        onFileChange(e){
            const files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;
            this.form.file = files[0];
        },

        save(){

            this.is_busy = true;

            if( this.element ){
                this.form
                    .transform(data => {
                        data.data = data.d;
                        delete data.d;
                        data._method = 'put';
                        return data;
                    })
                    .post(this.route('canvas-element.update', {canvas_element: this.element.id, ...this.global_url_params}), {
                        forceFormData: true,
                    });
            } else {
                this.form
                    .transform(data => {
                        data.data = data.d;
                        delete data.d;
                        return data;
                    })
                    .post(this.route('canvas-element.store', {...this.global_url_params}), {
                        forceFormData: true,
                    });
            }


        },
    },

    mounted() {

        switch (this.type){

            case 'resource':

                if( this.element ){
                    this.form = this.$inertia.form({
                        type: this.type,
                        name: this.element.name,
                        file: null,
                        groups: this.connected_group_ids,
                        d: {
                            options: this.element.data.options,
                            type: this.element.data.type,
                            url: this.element.data.url,
                            file: this.element.data?.file,
                            preview_url: this.element.data.preview_url,
                        },
                        tenants: this.element.tenants.map(t => t.id),
                    });
                }else{
                    this.form = this.$inertia.form({
                        type: this.type,
                        name: 'Untitled Resource',
                        file: null,
                        groups: [],
                        d: {
                            options: {width: 1},
                            type: 'link',
                            url: '',
                            file: '',
                            preview_url: '',
                        },
                        tenants: this.is_admin ? [ this.$page.props.active_tenant.id ] : [],
                    });
                }

                break;

            case 'activity':

                if( this.element ){
                    this.form = this.$inertia.form({
                        type: this.type,
                        name: this.element.name,
                        file: null,
                        groups: this.connected_group_ids,
                        d: {
                            preview_file: this.element.data?.preview_file,
                            teacher_file: this.element.data?.teacher_file,
                            file: this.element.data.file,
                            options: this.element.data.options,
                            uploadable: this.element.data.uploadable,
                            description: this.element.data.description,
                            student_instructions: this.element.data.student_instructions,
                            teacher_instructions: this.element.data.teacher_instructions,
                        },
                        tenants: this.element.tenants.map(t => t.id),
                    });
                }else{
                    this.form = this.$inertia.form({
                        type: this.type,
                        name: 'Untitled Activity',
                        file: null,
                        groups: [],
                        d: {
                            file: null,
                            teacher_file: null,
                            options: {width: 1},
                            uploadable: 'document',
                            description: '',
                            student_instructions: '',
                            teacher_instructions: '',
                        },
                        tenants: this.is_admin ? [ this.$page.props.active_tenant.id ] : [],
                    });
                }

                break;

        }

    }


}
</script>

<style lang="scss" scoped>
.preview{
    display: block;
    margin: 0.6rem 0;
    width: 260px;
    height: 260px;
    object-fit: cover;
}

textarea{
    min-height: 240px;
}

.checkboxes{
    display: flex;
    align-items: stretch;
    margin-left: -.3rem;
    margin-right: -.3rem;
    margin-bottom: 1rem;

    .checkbox {
        display: flex;
        width: 100%;
        flex: 1 1 100%;
        padding-left: .3rem;
        padding-right: .3rem;
    }
}
</style>
